import apiClient from '@/services/axios'
import apiHoldingClient from '@/services/axiosHolding'
import utilities from '@/services/utilities'

export async function getTickets(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/pos/tickets', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getOneTicket(id) {
	return new Promise((resolve, reject) => {
		return apiClient
			.get(`/pos/ticket/${id}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function requestAuthorization(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/pos/request-authorization`, payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function closeAdvanceTicket(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.put(`/pos/close-advance`, payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getPDFReport(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/reports/sales`, payload)
			.then((response) => {
				// console.log('response-->', response)
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getProductivityReport(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/reports/productivity`, payload)
			.then((response) => {
				// console.log('response-->', response)
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getSalesReport(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/reports/pos-sales`, payload)
			.then((response) => {
				// console.log('response-->', response)
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

/**
 * Obtiene los ingresos por dropshipping
 * @param {Object} payload - Filtros de consulta
 * @param {string} payload.fecha_desde - Fecha desde (YYYY-MM-DD)
 * @param {string} payload.fecha_hasta - Fecha hasta (YYYY-MM-DD)
 * @returns {Promise}
 */
export async function getDropshippingRevenue(payload) {
	return new Promise((resolve, reject) => {
		return apiHoldingClient
			.post('/mercadolibre/dashboard', {
				...payload,
				agrupacion: "dia",
			})
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

/**
 * Obtiene los ingresos por Shopify
 * @param {Object} payload - Filtros de consulta
 * @param {string} payload.fecha_desde - Fecha desde (YYYY-MM-DD)
 * @param {string} payload.fecha_hasta - Fecha hasta (YYYY-MM-DD)
 * @returns {Promise}
 */
export async function getShopifyRevenue(payload) {
	return new Promise((resolve, reject) => {
		return apiHoldingClient
			.post('/shopify/dashboard', {
				...payload,
				agrupacion: "dia",
			})
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
